<template>
  <div>
    <div id="search-banner" :class="searchContainerClass">
      <div class="main-search">
        <div class="btn-extra-search">
          <div
            :class="['btn-extra-search-circle toggle', { active: isSidebarVisible }]"
            :tooltip="this.$i18n.t('reszletes_kereses')"
            tabindex="0"
            @click="toggleFilter"
            @keypress.enter="toggleFilter"
          >
            <a :title="this.$i18n.t('reszletes_kereses')"
              ><span class="ml-2">{{ $i18n.t('reszletes_kereses') }}</span></a
            >
          </div>
        </div>
      </div>
    </div>

    <div id="filter-sidebar" :style="sidebarSlider">
      <div class="detailed-search">
        <div class="search-header">
          <h3>{{ $i18n.t('reszletes_kereses') }}</h3>
          <span class="fa fa-times" @click="toggleFilter"></span>
        </div>
        <div>
          <h4>{{ $i18n.t('CATEGORY_NAME') }}</h4>
          <div>
            <base-datalist ref="category" v-bind="filters.category" @form-item-changed="onChange"></base-datalist>
          </div>
        </div>

        <div>
          <h4>{{ $i18n.t('hir_forrasa') }}</h4>
          <div>
            <base-input v-bind="filters.newsSource" @form-item-changed="onChange"></base-input>
          </div>
        </div>
        <div>
          <h4>{{ $i18n.t('megjelenes_datuma') }}</h4>
          <div id="newsDate">
            <div>
              <date_interval v-bind="filters.newsDate" @form-item-changed="onChange"></date_interval>
            </div>
          </div>
        </div>
        <div>
          <h4>{{ $i18n.t('cikk_cim') }}</h4>
          <div id="newsTitle">
            <base-input v-bind="filters.newsTitle" @form-item-changed="onChange"></base-input>
          </div>
        </div>
        <div>
          <h4>{{ $i18n.t('cikk_tartalma') }}</h4>
          <div id="newsContent">
            <base-input v-bind="filters.newsContent" @form-item-changed="onChange"></base-input>
          </div>
        </div>

        <div><br /></div>
      </div>
      <div :style="sidebarSlider" class="btn-container">
        <a
          :href="`/news/list${filter}`"
          class="search-button"
          @click="setParams"
          @keypress.enter="setParams"
          tabindex="0"
          >{{ $i18n.t('alkalmaz') }}</a
        >
        <span class="search-clear" @click="onClearFilter" @keypress.enter="onClearFilter" tabindex="0">{{
          $i18n.t('szuro_torlese')
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
// import RadiobuttonList from '../form/controls/ChoiceList'
import BaseDatalist from '../form/controls/BaseDatalist'
import BaseInput from '../form/controls/BaseInput'
// import NumberInput from '../form/controls/NumberInput'
import EventBus from '../../utils/event-bus'
import { get, forEach, isEmpty, equals, isNil } from 'lodash'
import DateTime from '../form/controls/DateTime'
import date_interval from '../form/controls/DateTimeFilter'
//import ChoiceList from "../form/controls/ChoiceList";
import DateIntervalControl from '../list/search/fields/DateControl'
//import Checklist from "../form/controls/Checklist";

export default {
  name: 'TenderFilter',
  components: {
    // Checklist,
    DateIntervalControl,
    // NumberInput,
    BaseInput,
    //  RadiobuttonList,
    BaseDatalist,
    // ChoiceList,
    date_interval,
  },
  data() {
    return {
      isLoading: false,
      isSidebarVisible: false,
      recordsCount: null,
      processId: '6266b23574149b001164d003',
      filters: {
        searchTitle: '',
        category: {
          name: 'category',
          title: this.$i18n.t('CATEGORY_NAME'),
          placeholder: this.$i18n.t('CATEGORY_NAME'),
          data: 'ID_NEWS_CATEGORY',
          filterFormat: 'dropdownlist',
          type: 'dropdownlist',
          multiple: true,
          visible: true,
          searchable: true,
          localizeData: true,
          showSearchBar: false,
          value: [],
          list: '/api/Dynforms/pathfinder?type=query&value=627500a254744b001f9ef227',
        },
        newsSource: {
          name: 'newsSource',
          title: this.$i18n.t('hir_forrasa'),
          placeholder: this.$i18n.t('hir_forrasa'),
          data: 'SOURCE',
          filterFormat: 'text',
          type: 'text',
          multiple: false,
          visible: true,
          value: '',
        },
        newsDate: {
          name: 'newsDate',
          title: this.$i18n.t('megjelenes_datuma'),
          placeholder: this.$i18n.t('megjelenes_datuma'),
          data: 'DATE',
          filterFormat: 'date',
          type: 'date',
          visible: true,
          multiple: true,
          value: ['', ''],
        },
        newsTitle: {
          name: 'newsTitle',
          title: this.$i18n.t('cikk_cim'),
          placeholder: this.$i18n.t('cikk_cim'),
          data: 'TITLE',
          filterFormat: 'text',
          type: 'text',
          multiple: false,
          visible: true,
          value: '',
        },
        newsContent: {
          name: 'newsContent',
          title: this.$i18n.t('cikk_tartalma'),
          placeholder: this.$i18n.t('cikk_tartalma'),
          data: 'CONTENT',
          filterFormat: 'text',
          type: 'text',
          multiple: false,
          visible: true,
          value: '',
        },
      },
    }
  },
  computed: {
    sidebarSlider() {
      return this.isSidebarVisible ? 'left: 0' : 'left: -500px'
    },
    filter() {
      let search = ''
      forEach(this.filters, (param) => {
        if (param.name === 'newsDate' && param.value[0] === '' && param.value[1] === '') {
        } else {
          if (!isNil(param.value) && param.value.toString().length) {
            if (search.length) {
              search += '&'
            } else {
              search += '?'
            }
            if (Array.isArray(param.value)) {
              forEach(param.value, (value, idx) => {
                if (idx) {
                  search += '&'
                }
                if (param.multiple || param.type === 'radiobuttonlist') {
                  search += `${this.processId}[${param.data}][${idx}]=${value}`
                } else {
                  search += `${this.processId}[${param.data}]=${value}`
                }
              })
            } else {
              search += `${this.processId}[${param.data}]=${param.value}`
            }
          }
        }
      })
      return encodeURI(search.replace('+', '%2B'))
    },
    searchContainerClass() {
      return window.location.pathname === '/news/list' ? 'search-bar-top' : 'search-container'
    },
    searchTitle() {
      return this.filters.usearch.value && this.filters.usearch.value.length
        ? this.filters.usearch.value
        : this.$i18n.t('szures_eredmenye')
    },
  },
  methods: {
    toggleFilter() {
      this.isSidebarVisible = !this.isSidebarVisible
    },
    onChange(evt) {
      if (get(this.filters, [evt.name]).hasOwnProperty('value')) {
        const oldVal = this.filters[evt.name].value
        const newVal = evt.value
        if (!equals(oldVal, newVal)) {
          this.filters[evt.name].value = evt.value
          if (evt.name === 'order') {
            this.onEnter()
          }
        }
      }
      /*  if (evt.name === 'locationType') {
                  if (evt.value[0] === 'city') {
                    this.filters.location.placeholder = this.$i18n.t('telepules_neve_vagy_iranyitoszama')
                  } else {
                    this.filters.location.placeholder = this.$i18n.t('regio_neve')
                  }
                }*/
    },
    onClearFilter() {
      forEach(this.filters, (param) => {
        if (!isEmpty(param.value)) {
          if (Array.isArray(param.value)) {
            param.value = []
          } else {
            param.value = ''
          }
          this.filters.newsDate.value = ['', '']
        }
      })
      this.filters.status.value = []
      this.filters.order.value = ['name_asc']
      this.setParams()
    },

    onEnter() {
      this.setParams()
      window.location.href = `/news/list${this.filter}`
    },
    setParams() {
      this.isLoading = true
      window.localStorage.setItem('filters', JSON.stringify(this.filters))
    },
    setRecordsCount(evt) {
      this.recordsCount = evt.newVal
    },
    getStoredFilter() {
      if (!isEmpty(this.$route.query) && window.localStorage && !isEmpty(window.localStorage.filters)) {
        this.filters = JSON.parse(window.localStorage.getItem('filters'))
      }
    },
  },
  beforeCreate() {
    EventBus.$on('refresh-recordsCount', (evt) => this.setRecordsCount(evt))
  },
  beforeDestroy() {
    EventBus.$off('refresh-recordsCount', (evt) => this.setRecordsCount(evt))
  },
  mounted() {
    this.getStoredFilter()
  },
}
</script>

<style scoped>
.search-button {
  border: 1px solid #0a65ff;
  color: #fff;
}
.search-button:hover,
.search-button:active {
  background-color: white;
  border: 1px solid #0a65ff;
  color: #0a65ff !important;
}
</style>
